import Reveal from '@/pages/zz-review/components/Reveal';
import { Link } from 'react-router-dom';

const pillars = [
  '1001 宇宙書架',
  'RG / OG Portal',
  'AI Angel',
  'Evidence 成長紀錄',
  '生命實踐與文明共建',
];

export default function AboutAumSection() {
  return (
    <section id="aum" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-8 md:mb-10">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              About AUM
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              關於 AUM1001 Matrix
            </h2>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="rounded-lg border border-primary-200/70 bg-background-50 px-6 md:px-8 py-7 text-center mb-8">
            <p
              className="text-base md:text-lg text-foreground-800 leading-relaxed"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              本會為依法設立、非以營利為目的之公益性社會團體，以推行馨烏托邦為宗旨。
            </p>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-2xl mx-auto mb-8">
            Axion Utopia Matrix（AUM）社團法人世界馨烏托邦宇會，是以生命、科技、教育、產業與文明永續為核心的生命共同體平台。AUM1001
            Matrix 是「馨烏托邦宇會」面向世界的公開入口。
          </p>
        </Reveal>

        <Reveal delay={140}>
          <div className="flex flex-wrap justify-center gap-2">
            {pillars.map((pillar) => (
              <span
                key={pillar}
                className="text-sm text-foreground-700 bg-background-50 border border-background-200/70 px-3 py-1.5 rounded-full whitespace-nowrap"
              >
                {pillar}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={180}>
          <div className="mt-8 text-center">
            <Link to="/abaa-witness" className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800">
              閱讀 ABAA 生命經歷與任務見證
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
